module.exports = __webpack_public_path__ + "static/img/fz_fz_ys.650a51f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_fz_ys.png
// module id = c7qF
// module chunks = 0